export const imageUploadSlashItem = {
  title: 'Image',
  description: 'Upload an image',
  icon: '🖼️',
  group: 'Media',
  keywords: ['image', 'photo', 'picture', 'upload', 'img'],
  command: ({ editor, range }) => {
    editor.chain().focus().deleteRange(range).run();
    const controllerEl = editor.view.dom.closest('[data-controller~="tiptap"]');
    window.Stimulus.getControllerForElementAndIdentifier(controllerEl, 'tiptap').initiateUpload('image');
  },
};

export const attachmentUploadSlashItem = {
  title: 'Attachment',
  description: 'Upload a file attachment',
  icon: '📎',
  group: 'Media',
  keywords: ['attachment', 'file', 'upload', 'pdf', 'document'],
  command: ({ editor, range }) => {
    editor.chain().focus().deleteRange(range).run();
    const controllerEl = editor.view.dom.closest('[data-controller~="tiptap"]');
    window.Stimulus.getControllerForElementAndIdentifier(controllerEl, 'tiptap').initiateUpload('attachment');
  },
};
